//@ts-nocheck
import React from 'react';
import { Card } from 'react-bootstrap';
import {
  calculateReceivedTotalItems,
  calculateReceivedTotalValue,
} from '../utils/orderUtils';

const OrderSummaryCard = ({
  order,
  calculateTotalValue,
  calculateTotalItems,
}) => {
  const isReceived =
    order.status === 'completed' || order.status === 'odebrano';

  return (
    <Card>
      <Card.Header>
        <h6 className="mb-0">Podsumowanie</h6>
      </Card.Header>
      <Card.Body>
        <div className="mb-2">
          <strong>Liczba pozycji:</strong>
          <div>{order.items?.length || 0}</div>
        </div>
        <div className="mb-2">
          <strong>Łączna ilość:</strong>
          <div>
            {order.items?.reduce(
              (total, item) => total + item.quantity,
              0,
            ) || 0}{' '}
            szt.
            {isReceived && (
              <span className="text-muted">
                {' '}
                ({calculateReceivedTotalItems(order.items)} szt. odebrano)
              </span>
            )}
          </div>
        </div>
        <div className="mb-0">
          <strong>Wartość całkowita:</strong>
          <div className="h5 text-primary">
            {calculateTotalValue().toFixed(2)} zł
            {isReceived && (
              <div className="text-muted" style={{ fontSize: '0.9rem' }}>
                ({calculateReceivedTotalValue(order.items).toFixed(2)} zł
                rzeczywista)
              </div>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default OrderSummaryCard;
